"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.RawBooleanWithNull = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var react_onclickoutside_1 = __importDefault(require("react-onclickoutside"));
var BooleanWithNull = function (_a) {
    var input = _a.input, _b = _a.withNull, withNull = _b === void 0 ? true : _b;
    var isTrue = [true, 'true', 1, '1', 'j', 'J'].indexOf(input.value) !== -1;
    var isFalse = !withNull
        ? !isTrue
        : [false, 'false', 0, '0', 'n', 'N'].indexOf(input.value) !== -1;
    var className = {
        indeterminateCheckbox: true,
        'form-control': true,
        checked: isTrue,
        unchecked: isFalse,
        indeterminate: withNull && !isTrue && !isFalse
    };
    var changeValue = function (evt) { return input.onChange(isTrue ? '0' : (isFalse && withNull ? '-1' : '1')); };
    return (react_1["default"].createElement("div", { className: "form-group" },
        react_1["default"].createElement("fieldset", null,
            react_1["default"].createElement("input", { type: "hidden", name: input.name, value: input.value }),
            react_1["default"].createElement("div", { onClick: changeValue, className: (0, classnames_1["default"])(className) }))));
};
exports.RawBooleanWithNull = BooleanWithNull;
exports["default"] = (0, react_onclickoutside_1["default"])(BooleanWithNull, {
    // @ts-ignore
    handleClickOutside: function (instance) { return function (evt) { return instance.props.input.onBlur(); }; }
});
